import { useCallback } from 'react';
import classnames from 'classnames';
import { Pane, Text } from '@leverege/ui-elements';
import { DateTime } from 'luxon';
import S from './TimelineAxis.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TimelineAxis({
  projection,
  range,
  ticks
}) {
  const getTickLeftPosition = useCallback(dateTime => {
    const x = projection.toScreen(dateTime.valueOf());
    return x;
  }, [projection]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "timelineAxis",
    className: S.axis,
    children: ticks.map((e, n) => {
      if (!e.isTick && !e.isSubTick) {
        return null;
      }
      const left = getTickLeftPosition(e.date);
      return /*#__PURE__*/_jsx(Text, {
        variant: "timelineAxisTick",
        className: classnames(e.isTick && S.tick, e.isSubTick && S.subTick),
        "data-date": e.date.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS),
        style: {
          left
        },
        children: e.isTick ? e.label : '\u2022'
      }, e.key);
    })
  });
}